import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from 'react';
import t from '~t';
import _ from 'lodash-es';
import { useDispatch, useSelector } from 'react-redux';
import { makeCollectionPath } from '~data/selectors/collections';
import { load } from '~data/actions/collections';

import { Button, Label, Icon } from '~ui';
import CollectionIcon from '~co/collections/item/icon';
import Picker from '~co/collections/picker';
import Suggested from './suggested';

export default function BookmarkEditFormCollection({
  item,
  onChange,
  onSave,
}) {
  const dispatch = useDispatch();

  const [pick, setPick] = useState(false);

  //path — braces required: the arrow-expression form returns the action
  //object, which React stores as the effect destroy fn and calls on
  //unmount → "destroy is not a function" unmounts the whole tree
  useEffect(() => {
    dispatch(load());
  }, []);
  const getCollectionPath = useMemo(() => makeCollectionPath(), []);
  const path = useSelector((state) =>
    getCollectionPath(state, item.collectionId, { self: true }),
  );
  const pathText = useMemo(
    () => path.map((p) => p.title).join(' / '),
    [path],
  );

  //button
  const buttonRef = useRef(null);

  const onPickerClick = useCallback(
    (e) => {
      e.preventDefault();
      setPick(true);
    },
    [setPick],
  );

  const onPickerClose = useCallback(() => {
    setPick(false);
    buttonRef.current.focus();
  }, [buttonRef, setPick]);

  const pickerEvents = useMemo(
    () => ({
      onItemClick: ({ _id }) => {
        onChange({ collectionId: _id });
        if (typeof onSave == 'function') onSave();
        onPickerClose();
      },
    }),
    [onChange, onSave, onPickerClose],
  );

  return (
    <>
      <Label>{t.s('collection')}</Label>

      <div>
        <Button
          ref={buttonRef}
          href=''
          variant='flat'
          onClick={onPickerClick}
          title={pathText}
        >
          <CollectionIcon {...(_.last(path) || {})} />
          <span>{pathText || t.s('selectCollection') + '…'}</span>
          <Icon name='arrow' />
        </Button>

        <Suggested item={item} events={pickerEvents} />
      </div>

      {pick && (
        <Picker
          activeId={item.collectionId}
          events={pickerEvents}
          onClose={onPickerClose}
        />
      )}
    </>
  );
}
